import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { DisplayContainer } from "~/components/search/search-result-panel/components/dropdown-menu/styles";

import { SearchResultListSortingMenu } from "./sorting-menu";

export const StyledSearchResultListSortingMenu = styled(SearchResultListSortingMenu)`
  flex-shrink: 0;
`;

export const HeaderContainer = styled.div``;
export const AdvancedFilterOptionsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 28px;
  justify-content: flex-start;

  margin-block-end: 40px;

  ${DisplayContainer} {
    inline-size: max-content;
  }
`;

export const ResultAndSortingContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TotalResultText = styled.div`
  margin-block-end: 16px;

  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
`;

export const TotalCount = styled.span`
  color: #666666;
  font-weight: 700;
`;

export const NoResultsContainer = styled.div``;

export const NoResultsHeader = styled.p`
  margin-block: 0 16px;
  margin-inline: 0;

  color: #000000;
  font-weight: 900;
  font-size: 24px;
  font-family: ${fontRoboto};
  line-height: 28px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block: 0 12px;
    margin-inline: 0;

    font-weight: 900;
    font-size: 28px;
    font-family: ${fontRoboto};
    line-height: 33px;
  }
`;

export const NoResultsContent = styled.p`
  color: #000000;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;
